// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import { ApiUrls } from '../../utility/ApiUrls'

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
  return displayMenuBool
})

let getUserCall = false
const apiCall = async (method, endpoint, requestPayload) => {
  // console.log(method, endpoint, data)
  const authAxios = DefaultConfig().authAxios
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, requestPayload)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, requestPayload)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

export const GetUsers = createAsyncThunk("appCommonReducers/GetUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      allUsers.push({ userId: element.id, name: `${element.firstName} ${element.lastName}`, email: element.email, companyId: element.companyId, status: element.isActive ? 'Active' : 'InActive' })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllRoles = createAsyncThunk("appCommonReducers/GetAllRoles", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllRoles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)


  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
  const data = rdata.data
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetInspectionsByVesselId = createAsyncThunk("appCommonReducers/GetInspectionsByVesselId", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetInspectionsByVesselId}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCategories = createAsyncThunk("appCommonReducers/GetCategories", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCategories}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCategorieTypesDescription = createAsyncThunk("appCommonReducers/GetCategorieTypesDescription", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetCategorieTypesDescription}`
  const resultData = await apiCall(method, endpoint, wdata)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUsersPerDay = createAsyncThunk("appCommonReducers/GetUsersPerDay", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUsersPerDay}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserPerCountry = createAsyncThunk("appCommonReducers/GetUserPerCountry", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUserPerCountry}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetSessionsPerDay = createAsyncThunk("appCommonReducers/GetSessionsPerDay", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetSessionsPerDay}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserPerLanguage = createAsyncThunk("appCommonReducers/GetUserPerLanguage", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUserPerLanguage}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUsersPerAppVersion = createAsyncThunk("appCommonReducers/GetUsersPerAppVersion", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUsersPerAppVersion}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCrashesPerDay = createAsyncThunk("appCommonReducers/GetCrashesPerDay", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetCrashesPerDay}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCrashesPerOperatingSystem = createAsyncThunk("appCommonReducers/GetCrashesPerOperatingSystem", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetCrashesPerOperatingSystem}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCrashesGrouped = createAsyncThunk("appCommonReducers/GetCrashesGrouped", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetCrashesGrouped}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetErrorsPerDay = createAsyncThunk("appCommonReducers/GetErrorsPerDay", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetErrorsPerDay}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetErrorsPerOperatingSystem = createAsyncThunk("appCommonReducers/GetErrorsPerOperatingSystem", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetErrorsPerOperatingSystem}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetErrorsGrouped = createAsyncThunk("appCommonReducers/GetErrorsGrouped", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetErrorsGrouped}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetErrorDetails = createAsyncThunk("appCommonReducers/GetErrorDetails", async (payload) => {
  const method = 'post'
  const errorId = payload?.id || ''
  const endpoint = errorId ? `${ApiUrls.GetErrorDetails}?id=${encodeURIComponent(errorId)}` : `${ApiUrls.GetErrorDetails}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUniqueAppVersions = createAsyncThunk("appCommonReducers/GetUniqueAppVersions", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUniqueAppVersions}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCrashDetails = createAsyncThunk("appCommonReducers/GetCrashDetails", async (payload) => {
  const method = 'post'
  const crashId = payload?.id || ''
  const endpoint = crashId ? `${ApiUrls.GetCrashDetails}?id=${encodeURIComponent(crashId)}` : `${ApiUrls.GetCrashDetails}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetEventsByUser = createAsyncThunk("appCommonReducers/GetEventsByUser", async (payload) => {
  const method = 'get'
  const userId = payload?.userId || ''
  const timestamp = payload?.timestamp || ''

  // Build query parameters - only userId and timestamp
  const queryParams = []
  if (userId) {
    queryParams.push(`userId=${encodeURIComponent(userId)}`)
  }
  if (timestamp) {
    queryParams.push(`timestamp=${encodeURIComponent(timestamp)}`)
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : ''
  const endpoint = `${ApiUrls.GetEventsByUser}${queryString}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetEventsByUserForErrorInfo = createAsyncThunk("appCommonReducers/GetEventsByUserForErrorInfo", async (payload) => {
  const method = 'post'
  const userId = payload?.userId || ''

  // Build query parameters - only userId
  const queryParams = []
  if (userId) {
    queryParams.push(`userId=${encodeURIComponent(userId)}`)
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : ''
  const endpoint = `${ApiUrls.GetEventsByUserForErrorInfo}${queryString}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCrashDetailsPerDay = createAsyncThunk("appCommonReducers/GetCrashDetailsPerDay", async (payload) => {
  const method = 'post'
  const crashId = payload?.id || ''
  const endpoint = crashId ? `${ApiUrls.GetCrashDetailsPerDay}?id=${encodeURIComponent(crashId)}` : `${ApiUrls.GetCrashDetailsPerDay}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUsersPerIdiom = createAsyncThunk("appCommonReducers/GetUsersPerIdiom", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUsersPerIdiom}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUsersPerOperatingSystem = createAsyncThunk("appCommonReducers/GetUsersPerOperatingSystem", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUsersPerOperatingSystem}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserPerManufacturer = createAsyncThunk("appCommonReducers/GetUserPerManufacturer", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUserPerManufacturer}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUsersPerOperatingSystemVersion = createAsyncThunk("appCommonReducers/GetUsersPerOperatingSystemVersion", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUsersPerOperatingSystemVersion}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetPageViewsPerDay = createAsyncThunk("appCommonReducers/GetPageViewsPerDay", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetPageViewsPerDay}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetPageViewsGrouped = createAsyncThunk("appCommonReducers/GetPageViewsGrouped", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetPageViewsGrouped}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetFailedDependenciesPerDay = createAsyncThunk("appCommonReducers/GetFailedDependenciesPerDay", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetFailedDependenciesPerDay}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetTopDependencies = createAsyncThunk("appCommonReducers/GetTopDependencies", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetTopDependencies}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetDependencyAvgDurations = createAsyncThunk("appCommonReducers/GetDependencyAvgDurations", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetDependencyAvgDurations}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetFailedDependencies = createAsyncThunk("appCommonReducers/GetFailedDependencies", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetFailedDependencies}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetFailedDependenciesByKey = createAsyncThunk("appCommonReducers/GetFailedDependenciesByKey", async (payload) => {
  const method = 'post'
  const key = payload?.key || ''
  const dependencyMethod = payload?.method || 'Unknown'

  // Build query parameters - always include both key and method
  const queryParams = []
  if (key) {
    queryParams.push(`key=${encodeURIComponent(key)}`)
  }
  // Always include method in query params
  queryParams.push(`method=${encodeURIComponent(dependencyMethod)}`)

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : ''
  const endpoint = `${ApiUrls.GetFailedDependenciesByKey}${queryString}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetEventsGrouped = createAsyncThunk("appCommonReducers/GetEventsGrouped", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetEventsGrouped}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetEventsPerDay = createAsyncThunk("appCommonReducers/GetEventsPerDay", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetEventsPerDay}?eventName=${encodeURIComponent(payload.eventName)}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetPredefinedQueryNames = createAsyncThunk("appCommonReducers/GetPredefinedQueryNames", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetPredefinedQueryNames}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: {},
      spinner: true,
      tokenExp: false
    }
  }
})

export const RunQuery = createAsyncThunk("appCommonReducers/RunQuery", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.RunQuery}?query=${encodeURIComponent(payload.query)}`
  // Only include the field that has a value, not both
  const requestPayload = {}
  if (payload.numberOfDays !== undefined && payload.numberOfDays !== null) {
    requestPayload.numberOfDays = payload.numberOfDays
  }
  if (payload.numberOfHours !== undefined && payload.numberOfHours !== null) {
    requestPayload.numberOfHours = payload.numberOfHours
  }
  const resultData = await apiCall(method, endpoint, requestPayload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    usersData: null,
    uspiner: false,
    userRoleData: [],
    urspiner: false,

    vesselReportByDate: [],
    dppReportByDate: [],
    categories: [],
    allroles: [],
    spinner1: false,
    usersPerDayData: [],
    usersPerDaySpinner: false,
    userPerCountryData: [],
    userPerCountrySpinner: false,
    sessionsPerDayData: [],
    sessionsPerDaySpinner: false,
    userPerLanguageData: [],
    userPerLanguageSpinner: false,
    usersPerAppVersionData: [],
    usersPerAppVersionSpinner: false,
    crashesPerDayData: [],
    crashesPerDaySpinner: false,
    crashesPerOperatingSystemData: [],
    crashesPerOperatingSystemSpinner: false,
    crashesGroupedData: [],
    crashesGroupedSpinner: false,
    crashDetailsData: null,
    crashDetailsSpinner: false,
    crashDetailsPerDayData: [],
    crashDetailsPerDaySpinner: false,
    eventsByUserData: [],
    eventsByUserSpinner: false,
    eventsByUserForErrorInfoData: [],
    eventsByUserForErrorInfoSpinner: false,
    errorsPerDayData: [],
    errorsPerDaySpinner: false,
    errorsPerOperatingSystemData: [],
    errorsPerOperatingSystemSpinner: false,
    errorsGroupedData: [],
    errorsGroupedSpinner: false,
    errorDetailsData: null,
    errorDetailsSpinner: false,
    appVersions: [],
    appVersionsSpinner: false,
    usersPerOperatingSystemData: [],
    usersPerOperatingSystemSpinner: false,
    userPerManufacturerData: [],
    userPerManufacturerSpinner: false,
    usersPerOperatingSystemVersionData: [],
    usersPerOperatingSystemVersionSpinner: false,
    usersPerIdiomData: [],
    usersPerIdiomSpinner: false,
    pageViewsPerDayData: [],
    pageViewsPerDaySpinner: false,
    pageViewsGroupedData: [],
    pageViewsGroupedSpinner: false,
    failedDependenciesPerDayData: [],
    failedDependenciesPerDaySpinner: false,
    topDependenciesData: [],
    topDependenciesSpinner: false,
    dependencyAvgDurationsData: [],
    dependencyAvgDurationsSpinner: false,
    failedDependenciesData: [],
    failedDependenciesSpinner: false,
    failedDependenciesByKeyData: [],
    failedDependenciesByKeySpinner: false,
    eventsData: [],
    eventsSpinner: false,
    eventsPerDayData: [],
    eventsPerDaySpinner: false,
    predefinedQueryNamesData: {},
    predefinedQueryNamesSpinner: false,
    runQueryData: null,
    runQuerySpinner: false,
    globalFilters: {
      textFilter: null
    }
  },
  reducers: {
    setGlobalFilter: (state, action) => {
      state.globalFilters = { ...state.globalFilters, ...action.payload }
    },
    clearGlobalFilters: (state) => {
      state.globalFilters = { textFilter: null }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(displayMenu.fulfilled, (state, action) => {
        state.displayMenuBool = action.payload
      })
      // start role management
      .addCase(GetUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersData = action.payload.data
        }
      })
      .addCase(GetUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userRoleData = action.payload.data
        }
      })
      .addCase(SaveUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetCategories.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner1 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.categories = action.payload.data
        }
      })
      // .addCase(GetDPPReportByDate.fulfilled, (state, action) => {
      //   if (action.payload) {
      //     state.urspiner = action.payload.spinner
      //     state.tokenExp = action.payload.tokenExp
      //     state.dppReportByDate = action.payload.data
      //   }
      // })
      .addCase(GetAllRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allroles = action.payload.data
        }
      })
      .addCase(GetUsersPerDay.pending, (state) => {
        state.usersPerDaySpinner = false
      })
      .addCase(GetUsersPerDay.fulfilled, (state, action) => {
        if (action.payload) {
          state.usersPerDaySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersPerDayData = action.payload.data
        }
      })
      .addCase(GetUserPerCountry.pending, (state) => {
        state.userPerCountrySpinner = false
      })
      .addCase(GetUserPerCountry.fulfilled, (state, action) => {
        if (action.payload) {
          state.userPerCountrySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userPerCountryData = action.payload.data
        }
      })
      .addCase(GetSessionsPerDay.pending, (state) => {
        state.sessionsPerDaySpinner = false
      })
      .addCase(GetSessionsPerDay.fulfilled, (state, action) => {
        if (action.payload) {
          state.sessionsPerDaySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.sessionsPerDayData = action.payload.data
        }
      })
      .addCase(GetUserPerLanguage.pending, (state) => {
        state.userPerLanguageSpinner = false
      })
      .addCase(GetUserPerLanguage.fulfilled, (state, action) => {
        if (action.payload) {
          state.userPerLanguageSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userPerLanguageData = action.payload.data
        }
      })
      .addCase(GetUsersPerAppVersion.pending, (state) => {
        state.usersPerAppVersionSpinner = false
      })
      .addCase(GetUsersPerAppVersion.fulfilled, (state, action) => {
        if (action.payload) {
          state.usersPerAppVersionSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersPerAppVersionData = action.payload.data
        }
      })
      .addCase(GetCrashesPerDay.pending, (state) => {
        state.crashesPerDaySpinner = false
      })
      .addCase(GetCrashesPerDay.fulfilled, (state, action) => {
        if (action.payload) {
          state.crashesPerDaySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.crashesPerDayData = action.payload.data
        }
      })
      .addCase(GetCrashesPerOperatingSystem.pending, (state) => {
        state.crashesPerOperatingSystemSpinner = false
      })
      .addCase(GetCrashesPerOperatingSystem.fulfilled, (state, action) => {
        if (action.payload) {
          state.crashesPerOperatingSystemSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.crashesPerOperatingSystemData = action.payload.data
        }
      })
      .addCase(GetCrashesGrouped.pending, (state) => {
        state.crashesGroupedSpinner = false
      })
      .addCase(GetCrashesGrouped.fulfilled, (state, action) => {
        if (action.payload) {
          state.crashesGroupedSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.crashesGroupedData = action.payload.data
        }
      })
      .addCase(GetCrashDetails.pending, (state) => {
        state.crashDetailsSpinner = false
      })
      .addCase(GetCrashDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.crashDetailsSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.crashDetailsData = action.payload.data
        }
      })
      .addCase(GetCrashDetailsPerDay.pending, (state) => {
        state.crashDetailsPerDaySpinner = false
      })
      .addCase(GetCrashDetailsPerDay.fulfilled, (state, action) => {
        if (action.payload) {
          state.crashDetailsPerDaySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.crashDetailsPerDayData = action.payload.data
        }
      })
      .addCase(GetEventsByUser.pending, (state) => {
        state.eventsByUserSpinner = false
      })
      .addCase(GetEventsByUser.fulfilled, (state, action) => {
        if (action.payload) {
          state.eventsByUserSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.eventsByUserData = action.payload.data
        }
      })
      .addCase(GetEventsByUserForErrorInfo.pending, (state) => {
        state.eventsByUserForErrorInfoSpinner = false
      })
      .addCase(GetEventsByUserForErrorInfo.fulfilled, (state, action) => {
        if (action.payload) {
          state.eventsByUserForErrorInfoSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.eventsByUserForErrorInfoData = action.payload.data
        }
      })
      .addCase(GetErrorsPerDay.pending, (state) => {
        state.errorsPerDaySpinner = false
      })
      .addCase(GetErrorsPerDay.fulfilled, (state, action) => {
        if (action.payload) {
          state.errorsPerDaySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.errorsPerDayData = action.payload.data
        }
      })
      .addCase(GetErrorsPerOperatingSystem.pending, (state) => {
        state.errorsPerOperatingSystemSpinner = false
      })
      .addCase(GetErrorsPerOperatingSystem.fulfilled, (state, action) => {
        if (action.payload) {
          state.errorsPerOperatingSystemSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.errorsPerOperatingSystemData = action.payload.data
        }
      })
      .addCase(GetErrorsGrouped.pending, (state) => {
        state.errorsGroupedSpinner = false
      })
      .addCase(GetErrorsGrouped.fulfilled, (state, action) => {
        if (action.payload) {
          state.errorsGroupedSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.errorsGroupedData = action.payload.data
        }
      })
      .addCase(GetErrorDetails.pending, (state) => {
        state.errorDetailsSpinner = false
      })
      .addCase(GetErrorDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.errorDetailsSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.errorDetailsData = action.payload.data
        }
      })
      .addCase(GetUniqueAppVersions.fulfilled, (state, action) => {
        if (action.payload) {
          state.appVersionsSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.appVersions = action.payload.data
        }
      })
      .addCase(GetUsersPerOperatingSystem.pending, (state) => {
        state.usersPerOperatingSystemSpinner = false
      })
      .addCase(GetUsersPerOperatingSystem.fulfilled, (state, action) => {
        if (action.payload) {
          state.usersPerOperatingSystemSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersPerOperatingSystemData = action.payload.data
        }
      })
      .addCase(GetUserPerManufacturer.pending, (state) => {
        state.userPerManufacturerSpinner = false
      })
      .addCase(GetUserPerManufacturer.fulfilled, (state, action) => {
        if (action.payload) {
          state.userPerManufacturerSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userPerManufacturerData = action.payload.data
        }
      })
      .addCase(GetUsersPerOperatingSystemVersion.pending, (state) => {
        state.usersPerOperatingSystemVersionSpinner = false
      })
      .addCase(GetUsersPerOperatingSystemVersion.fulfilled, (state, action) => {
        if (action.payload) {
          state.usersPerOperatingSystemVersionSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersPerOperatingSystemVersionData = action.payload.data
        }
      })
      .addCase(GetUsersPerIdiom.pending, (state) => {
        state.usersPerIdiomSpinner = false
      })
      .addCase(GetUsersPerIdiom.fulfilled, (state, action) => {
        if (action.payload) {
          state.usersPerIdiomSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersPerIdiomData = action.payload.data
        }
      })
      .addCase(GetPageViewsPerDay.pending, (state) => {
        state.pageViewsPerDaySpinner = false
      })
      .addCase(GetPageViewsPerDay.fulfilled, (state, action) => {
        if (action.payload) {
          state.pageViewsPerDaySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.pageViewsPerDayData = action.payload.data
        }
      })
      .addCase(GetPageViewsGrouped.pending, (state) => {
        state.pageViewsGroupedSpinner = false
      })
      .addCase(GetPageViewsGrouped.fulfilled, (state, action) => {
        if (action.payload) {
          state.pageViewsGroupedSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.pageViewsGroupedData = action.payload.data
        }
      })
      .addCase(GetFailedDependenciesPerDay.pending, (state) => {
        state.failedDependenciesPerDaySpinner = false
      })
      .addCase(GetFailedDependenciesPerDay.fulfilled, (state, action) => {
        if (action.payload) {
          state.failedDependenciesPerDaySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.failedDependenciesPerDayData = action.payload.data
        }
      })
      .addCase(GetTopDependencies.pending, (state) => {
        state.topDependenciesSpinner = false
      })
      .addCase(GetTopDependencies.fulfilled, (state, action) => {
        if (action.payload) {
          state.topDependenciesSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.topDependenciesData = action.payload.data
        }
      })
      .addCase(GetDependencyAvgDurations.pending, (state) => {
        state.dependencyAvgDurationsSpinner = false
      })
      .addCase(GetDependencyAvgDurations.fulfilled, (state, action) => {
        if (action.payload) {
          state.dependencyAvgDurationsSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.dependencyAvgDurationsData = action.payload.data
        }
      })
      .addCase(GetFailedDependencies.pending, (state) => {
        state.failedDependenciesSpinner = false
      })
      .addCase(GetFailedDependencies.fulfilled, (state, action) => {
        if (action.payload) {
          state.failedDependenciesSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.failedDependenciesData = action.payload.data
        }
      })
      .addCase(GetFailedDependenciesByKey.pending, (state) => {
        state.failedDependenciesByKeySpinner = false
      })
      .addCase(GetFailedDependenciesByKey.fulfilled, (state, action) => {
        if (action.payload) {
          state.failedDependenciesByKeySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.failedDependenciesByKeyData = action.payload.data
        }
      })
      .addCase(GetEventsGrouped.pending, (state) => {
        state.eventsSpinner = false
      })
      .addCase(GetEventsGrouped.fulfilled, (state, action) => {
        if (action.payload) {
          state.eventsSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.eventsData = action.payload.data
        }
      })
      .addCase(GetEventsPerDay.pending, (state) => {
        state.eventsPerDaySpinner = false
      })
      .addCase(GetEventsPerDay.fulfilled, (state, action) => {
        if (action.payload) {
          state.eventsPerDaySpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.eventsPerDayData = action.payload.data
        }
      })
      .addCase(GetPredefinedQueryNames.pending, (state) => {
        state.predefinedQueryNamesSpinner = false
      })
      .addCase(GetPredefinedQueryNames.fulfilled, (state, action) => {
        if (action.payload) {
          state.predefinedQueryNamesSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.predefinedQueryNamesData = action.payload.data
        }
      })
      .addCase(RunQuery.pending, (state) => {
        state.runQuerySpinner = true
        state.runQueryData = null
      })
      .addCase(RunQuery.fulfilled, (state, action) => {
        if (action.payload) {
          state.runQuerySpinner = false
          state.tokenExp = action.payload.tokenExp
          state.runQueryData = action.payload.data
        }
      })
      .addCase(RunQuery.rejected, (state) => {
        state.runQuerySpinner = false
      })
  }
})
export const { handleAddtoCart, setGlobalFilter, clearGlobalFilters } = commonreducerSlice.actions
export default commonreducerSlice.reducer
